export const checkRequiredValue = (value: number, required: number) =>
  !!value && (required & value) === required;
